export default __webpack_public_path__ + "static/ymca-logo-6d69add0dc5b7aa1d1a703b355fd5230.png";